import { isNumber } from 'rev-shared/util';
import { getUrlPath } from './Util.Service';

const macRegex = /^([a-f0-9]{2}[.:-]?){5}[a-f0-9]{2}$/i;

export const ValidationRules = {

	// check if something is an integer/whole number
	checkInteger(value: string|number): boolean {
		if(isNumber(value)) {
			value = value + '';
		}
		return !value || !!(/^-?[0-9]+$/).exec(value);
	},

	/**
	 * Check if something is an email with intentionally lax rules.
	 * The email must contain a single '@'.
	 * The middle of the domain name(not first or last char) must contain at least one '.'. (first or last char can also be '.', but the middle must contain a period too.)
	 * No spaces are allowed.
	 */
	checkEmail(value: string): boolean {
		if(!value) {return true;}
		//Regex validation was being flagged for polynomial runtime. Replacing with logic
		const atIndex = value.indexOf('@');
		const domainSubstr = value.slice(atIndex+2, -1);
		//ensure period in middle chars of domain name.
		const periodIndex = domainSubstr.indexOf('.');

		return atIndex > 0 &&
			atIndex === value.lastIndexOf('@') &&
			periodIndex >= 0 &&
			!/\s/.test(value);
	},

	// check if something is a 'short' text field (100 characters)
	checkShortText(value: string): boolean {
		return this.checkLengthBetween(value, 0, 100);
	},
	// check if something is a 'medium' text field (500 characters)
	checkMediumText(value: string): boolean {
		return this.checkLengthBetween(value, 0, 500);
	},
	// check if something is a 'long' text field (5000 characters)
	checkLongText(value: string): boolean {
		return this.checkLengthBetween(value, 0, 5000);
	},
	// helper function to check if something is between a certain length (useful for postal codes, phone numbers, etc.)
	checkLengthBetween(value: string, min: number, max: number): boolean {
		return !value || checkRange(value.length, min, max);
	},
	// helper function to check if a string is a valid hostname
	// allowed: lower case letters, numbers, dots, and hyphens
	// dots and hyphens cannot be the first character
	checkHostnameText(value: string): boolean {
		return !value || !!value.match(/^[a-z0-9][a-z0-9\-.]+$/i);
	},

	checkMacAddress(value: string): boolean {
		return !value || !!value.match(macRegex);
	},

	checkUrl(value: string, allowedSchemes?: string[]): boolean {
		//very loose URL check
		//http://tools.ietf.org/html/rfc3986
		if(!value) {
			return true;
		}

		try {
			const url = new URL(value);
			const scheme = url.protocol.replaceAll(':', '');
			return !allowedSchemes || allowedSchemes.includes(scheme);
		}catch {
			return false;
		}
	},

	checkValidCommaSeparatedEmails(value: string): boolean {
		if (!value) {
			return true;
		}
		const emails = value.split(',');
		return emails.every((email, i) => this.checkEmail(email) && emails.indexOf(email, i+1) === -1);
	},

	checkHlsPlaybackUrl(value: string): boolean {
		if (!value) {
			return true;
		}
		const path = getUrlPath(value);
		return path?.endsWith('.m3u8');
	}

};

function checkRange(value: number, min: number, max: number): boolean{
	return	(!isNumber(min) || value >= min) &&
			(!isNumber(max) || value <= max);
}
